import { Navigate, Routes, Route } from "react-router-dom";

import { WelcomePage } from "@/pages/WelcomePage";
import { HomePage } from "@/pages/HomePage";
import { AccountsPage } from "@/pages/AccountsPage";
import { TemplatesPage } from "@/pages/TemplatesPage";
import { ChatsPage } from "@/pages/ChatsPage";
import { MailingPage } from "@/pages/MailingPage";
import { OutreachPage } from "@/pages/OutreachPage";
import { StoriesPage } from "@/pages/StoriesPage";
import { StatsPage } from "@/pages/StatsPage";
import { BillingPage } from "@/pages/BillingPage";
import { ReferralsPage } from "@/pages/ReferralsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { AdminPage } from "@/pages/AdminPage";
import { AppShell } from "@/components/AppShell";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<WelcomePage />} />
      <Route path="/app" element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="accounts" element={<AccountsPage />} />
        <Route path="templates" element={<TemplatesPage />} />
        <Route path="chats" element={<ChatsPage />} />
        <Route path="mailing" element={<MailingPage />} />
        <Route path="outreach" element={<OutreachPage />} />
        <Route path="stories" element={<StoriesPage />} />
        <Route path="stats" element={<StatsPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="referrals" element={<ReferralsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
